<template>
  <div class="block--cash-content-wrap">
    <div class="cash-chart-title">今日资金(元)</div>
    <div class="cash-chart-sec-title">主力净流入 <span :class="dayChart && dayChart.miceValue >= 0 ? 'up' : 'down'" style="margin-left: 5px;">{{dayChart && hanldeUnit(dayChart.miceValue)}}</span></div>
    <div class="cash-chart-pointers">
      <div class="legend-block"><span class="rise-block"></span>主力流入&nbsp;<span class="up" style="margin-left: 5px;"> {{dayChart && hanldeUnit(dayChart.r_in)}}</span></div>
      <div class="legend-block"><span class="green-block"></span>主力流出&nbsp;<span class="down" style="margin-left: 5px;"> {{dayChart && hanldeUnit(dayChart.r_out)}}</span></div>
    </div>
    <div id="cash-day-pie-chart"></div>
    <div style="padding:0 12px;"><div id="cash-day-pie-chart2"></div></div>
    <div style="height:6px;background:#f5f5f5;"></div>
    <div class="cash-chart-title" style="margin-top:15px;">近五日主力资金(元)</div>
    <div class="cash-chart-sec-title">主力净流入 <span :class="this.fiveChart && this.fiveChart.r_in >= 0 ? 'up' : 'down'">{{this.fiveChart && hanldeUnit(this.fiveChart.r_in)}}</span></div>
    <div class="cash-chart-pointers">
      <div class="legend-block"><span class="rise-block"></span>资金流入</div>
      <div class="legend-block"><span class="green-block"></span>资金流出</div>
    </div>
    <div style="padding:0 12px;"><div id="cash-bar-chart"></div></div>
  </div>
</template>
<script>
import { request } from '@/api/request'

import echarts from 'echarts'
export default {
  data() {
    return {
      dayChartEle: null,
      dayChartBarEle: null,
      fiveChartEle: null,
      dayChart: {
        r_in: '--',
        r_out: '--',
        miceValue: '--'
      },
      fiveChart: {
        r_in: '--'
      }
    }
  },
  methods: {
    renderDayChart: function (series) {
      const option = {
        title: {
          text: `主力资金`,
          left: '41%',
          top: '42%',
          textStyle: {
            fontSize: 12,
            color: '#666'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{d}%'
        },
        series
      };
      this.dayChartEle.setOption(option, true);
    },
    hanldeUnit(num) {
      if(Number.isNaN(+num)) {return '--'}
      return (+num > 100000000 || +num < -100000000) ? (+num/100000000).toFixed(2) + '亿' : (+num/10000).toFixed(2) + '万'
    },
    createDayChartSeries (info) {
      try {
        let data = info.FundflowTurnover
        if (!info.FundflowTurnover) {
          data = {
            SuperGrp_TurnoverIn:0,
            LargeGrp_TurnoverIn:0,
            SuperGrp_TurnoverOut:0,
            LargeGrp_TurnoverOut:0
          }
        }
        const {SuperGrp_TurnoverIn, LargeGrp_TurnoverIn, SuperGrp_TurnoverOut, LargeGrp_TurnoverOut} = data
        let r_in = (SuperGrp_TurnoverIn + LargeGrp_TurnoverIn)
        let r_out = (SuperGrp_TurnoverOut + LargeGrp_TurnoverOut)
        let r_all = r_in - r_out
        let r_inPerc = (r_in/(r_in + r_out)*100).toFixed(2)+ '%'
        let r_outPerc = (r_out/(r_in + r_out)*100).toFixed(2)+ '%'
        this.dayChart= {
          r_in,
          r_out,
          miceValue: r_all
        }
        return [
          {
            type: 'pie',
            radius: ['100%', '55%'],
            center: ['50%', '50%'],
            labelLine: {
              show: true,
              length: 40,
              length2: 40
            },
            itemStyle: {
              borderWidth: 2,
              borderColor: '#ffffff'
            },
            label: {
              color: '#666666',
              fontSize: 12
            },
            data: [
              {
                name: r_outPerc,
                value: r_out,
                itemStyle: {
                  color: '#1BAA3C'
                }
              },
              {
                name: r_inPerc,
                value: r_in,
                itemStyle: {
                  color: '#E63535'
                }
              }
            ]
          }
        ]
      } catch (error) {
        console.log(error)
      }
    },
    createDayChartBarSeries (info) {
      let {SuperGrp_TurnoverInSubOut, LargeGrp_TurnoverInSubOut, MediumGrp_TurnoverInSubOut, LittleGrp_TurnoverInSubOut} = info.FundflowTurnover
      let dataList = []
      let avgnum = 100000000
      dataList.push({
        value: SuperGrp_TurnoverInSubOut,
        label: {
          position: +SuperGrp_TurnoverInSubOut > 0 ? 'top' : 'bottom'
        }
      })
      dataList.push({
        value: LargeGrp_TurnoverInSubOut,
        label: {
          position: +LargeGrp_TurnoverInSubOut > 0 ? 'top' : 'bottom'
        }
      })
      dataList.push({
        value: MediumGrp_TurnoverInSubOut,
        label: {
          position: +MediumGrp_TurnoverInSubOut > 0 ? 'top' : 'bottom'
        }
      })
      dataList.push({
        value: LittleGrp_TurnoverInSubOut,
        label: {
          position: +LittleGrp_TurnoverInSubOut > 0 ? 'top' : 'bottom'
        }
      })
      return {
        grid: {
        },
        series: [
          {
            type: 'bar',
            data: dataList,
            barWidth: 46,
            itemStyle: {
              color: function (c) {
                if (+c.data.value < 0) {
                  return '#1BAA3C'
                } else {
                  return '#E63535'
                }
              }
            },
            label: {
              show: true,
              formatter: function(p){
                let num = p.value
                return (+num > 100000000 || +num < -100000000) ? (+num/100000000).toFixed(2) + '亿' : (+num/10000).toFixed(2) + '万'
              },
              fontSize: 12,
              fontWeight: 'bold'
            }
          }
        ],
        xAxis: ['净特大单', '净大单', '净中单', '净小单']
      }
    },
    renderDayBarChart: function (ret) {
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{c}'
        },
        grid: {
          left: 40,
          right: 40,
          top: 25,
          bottom: 40
        },
        xAxis: {
          type: 'category',
          data: ret.xAxis,
          boundaryGap: false,
          nameRotate: 0,
          nameGap: 30,
          nameTextStyle: {
            fontSize: 12,
            color: '#666666'
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#EBEBEB'
            }
          },
          axisLabel: {
            color: '#666666',
            fontSize: 14,
            interval: 0,
            margin: 18
          }
        },
        yAxis: {
          show: false
        },
        series: ret.series
      };
      this.dayChartBarEle.setOption(option, true);
    },
    renderFiveChart (ret) {
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{c}'
        },
        grid: {
          left: 40,
          right: 40,
          top: 25,
          bottom: 40
        },
        xAxis: {
          type: 'category',
          data: ret.xAxis,
          boundaryGap: false,
          nameTextStyle: {
            fontSize: 12
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#EBEBEB'
            }
          },
          axisLabel: {
            color: '#666666',
            fontSize: 14,
            margin: 18
          }
        },
        yAxis: {
          show: false
        },
        series: ret.series
      };
      this.fiveChartEle.setOption(option, true);
    },
    createFiveSeries (data) {
      let xAxis = []
      let dataList = []
      let avgnum = 100000000
      let sumR_in = 0
      data.map(o=>{
        sumR_in += o.Flowinout
        let dayStr = String(o.Tradingday).slice(-4).split('')
        dayStr.splice(2,0,'-')
        xAxis.push(dayStr.join(''))
        dataList.push({
          value: o.Flowinout,
          label: {
            position: +o.Flowinout > 0 ? 'top' : 'bottom'
          }
        })
      })
      
      this.fiveChart= {
        r_in: sumR_in,
      }
      return {
        series: [
          {
            type: 'bar',
            data: dataList,
            barWidth: 32,
            itemStyle: {
              color: function (c) {
                if (c.data.value < 0) {
                  return '#1BAA3C'
                } else {
                  return '#E63535'
                }
              }
            },
            label: {
              show: true,
              formatter: function(p){
                let num = p.value
                return (+num > 100000000 || +num < -100000000) ? (+num/100000000).toFixed(2) + '亿' : (+num/10000).toFixed(2) + '万'
              },
              fontSize: 12,
              fontWeight: 'bold'
            }
          }
        ],
        xAxis
      }
    },

    getData() {
      const params = {
        stockCode: this.$route.params.prodCode+'.XBHS'
      }
      request._get(
        request.apis.quote.todayCapitalFlow,
        params,
        true
      ).then(res => {
        this.renderDayChart(this.createDayChartSeries(res))
        this.renderDayBarChart(this.createDayChartBarSeries(res))
      })
      request._get(
        request.apis.quote.fiveDayCapitalFlow,
        params,
        true
      ).then(res => {
        this.renderFiveChart(this.createFiveSeries(res.slice(-5)))
      })
    }
  },
  mounted(){
    this.dayChartEle = echarts.init(document.getElementById('cash-day-pie-chart'))
    this.dayChartBarEle = echarts.init(document.getElementById('cash-day-pie-chart2'))
    this.fiveChartEle = echarts.init(document.getElementById('cash-bar-chart'))
    this.getData()
  }
}
</script>
<style lang="stylus" scoped>
  .block--cash-content-wrap
    padding 15px 0 64px
    *
      box-sizing border-box
  .cash-chart-title
    color #333
    font-size 15px
    margin-bottom 13px
    font-weight bold
    padding 0 12px
  .cash-chart-sec-title
    padding 0 12px
    margin-bottom 6px
    font-size 14px
    color #333
  .up
    color #F43737
    font-weight bold
  .down
    color #1BAA3C
    font-weight bold
  #cash-day-pie-chart
    width 100%
    height 130px
    margin 20px auto
    padding 0 12px
  #cash-day-pie-chart2
    width 100%
    height 210px
    margin 18px auto 20px
    background-color #F5F5F5
  #cash-bar-chart
    width 100%
    height 210px
    margin 20px auto
    background-color #F5F5F5
  .cash-chart-pointers
    position relative
    display flex
    padding 0 12px
    color #333
    font-size 14px
    .legend-block
      display flex
      align-items center
    .legend-block:last-child
      position absolute
      left 200px
    .rise-block,.green-block
      display inline-block
      width 13px
      height 13px
      margin-right 4px
    .rise-block
      background-color #E63535
    .green-block
      background-color #1BAA3C
</style>